import { e } from '@frontend/shared/src/utils/e';
import { selectFile } from '@frontend/shared/src/utils/files';
import { getAverageColorHex } from '@frontend/shared/src/utils/images';
import { Wallpapers } from '../services/WallpapersService';
import { FileStorage } from '../services/FileStorageService';
import type { ReactiveWallpaper } from '../reactive/ReactiveWallpaper';

export class SPADialogSettingsWallpaper extends HTMLDivElement {
  private _imgElement: HTMLImageElement | null = null;
  private _videoElement: HTMLVideoElement | null = null;
  private _addElement: HTMLButtonElement | null = null;
  private _removeElement: HTMLButtonElement | null = null;
  private _customCssElement: HTMLButtonElement | null = null;

  constructor(private readonly wallpaper: ReactiveWallpaper) {
    super();

    this.setAttribute('is', 'spa-dialog-settings-wallpaper');
  }

  connectedCallback() {
    const updateSrc = () => {
      if (this._imgElement) {
        this._imgElement.src = this.wallpaper.type === 'image' ? (this.wallpaper.src ?? '') : '';
      }

      if (this._videoElement) {
        this._videoElement.src = this.wallpaper.type === 'video' ? (this.wallpaper.src ?? '') : '';
      }
    };

    this.wallpaper.onPropertyChange('src', updateSrc);
    this.wallpaper.onPropertyChange('type', updateSrc);

    this._imgElement =
      this.querySelector<HTMLImageElement>('img') ??
      (() => {
        const element = e.img({
          src: this.wallpaper.type === 'image' ? (this.wallpaper.src ?? '') : '',
          width: 204,
          height: 116,
          onclick: () => {
            if (this.wallpaper.src) {
              Wallpapers.select(this.wallpaper.id);
            }
          },
          onload: () => {
            if (!this.wallpaper.color) {
              this.wallpaper.color = getAverageColorHex(element);
            }
          },
        });

        return element;
      })();

    this._videoElement =
      this.querySelector<HTMLVideoElement>('video') ??
      (() => {
        const element = e.video({
          src: this.wallpaper.type === 'video' ? (this.wallpaper.src ?? '') : '',
          loop: true,
          muted: true,
          controls: false,
          autoplay: true,
          width: 204,
          height: 116,
          onclick: () => {
            if (this.wallpaper.src) {
              Wallpapers.select(this.wallpaper.id);
            }
          },
        });

        return element;
      })();

    this._addElement =
      this.querySelector<HTMLButtonElement>('.select') ??
      (() =>
        e.button(
          {
            className: 'spa-button spa-light spa-autosize select',
            onclick: () => {
              selectFile(file => {
                if (file && (file.type.startsWith('image') || file.type.startsWith('video'))) {
                  const uuid = crypto.randomUUID();

                  FileStorage.store(uuid, file).then(() => {
                    this.wallpaper.type = file.type.startsWith('image') ? 'image' : 'video';
                    this.wallpaper.src = URL.createObjectURL(file);
                    this.wallpaper.file_id = uuid;

                    Wallpapers.select(this.wallpaper.id);
                  });
                }
              });
            },
          },
          ['+']
        ))();

    if (this.wallpaper.id !== 0) {
      this._customCssElement =
        this.querySelector<HTMLButtonElement>('.custom-css') ??
        (() =>
          e.button({
            className: 'spa-button spa-blue spa-autosize custom-css',
            innerHTML:
              '<svg height="24" width="24"><use xlink:href="#icon-custom-css"></use></svg>',
            onclick: () => {
              const css = prompt('Оставь надежду всяк сюда жмащий', this.wallpaper.css || '');

              if (css !== null) {
                this.wallpaper.css = css;
              }
            },
          }))();

      this._removeElement =
        this.querySelector<HTMLButtonElement>('.remove') ??
        (() =>
          e.button({
            className: 'spa-button spa-red spa-autosize remove',
            innerHTML: '<svg height="24" width="24"><use xlink:href="#icon-trash"></use></svg>',
            onclick: () => {
              Wallpapers.remove(this.wallpaper.id);
            },
          }))();
    }

    [
      this._imgElement,
      this._videoElement,
      this._addElement,
      this._customCssElement,
      this._removeElement,
    ].forEach(element => {
      if (element) {
        this.appendChild(element);
      }
    });
  }
}

customElements.define('spa-dialog-settings-wallpaper', SPADialogSettingsWallpaper, {
  extends: 'div',
});
